import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { Row, Col } from "react-flexbox-grid";
import styles from "./styles/tickers.module.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import Ticker from "./components/Ticker";
import { FaRegQuestionCircle } from "react-icons/fa";
import ConfirmationModal from "../../components/ConfirmationModal";
import { getTickers, putTicker } from "../../actions/tickers-actions";
import * as Validate from "../../helpers/validations";
import cities from "../settings/citiesUSA";
import Tutorial from '../../components/Tutorial'

export class Tickers extends Component {
  constructor(props) {
    super(props);
    this.user = JSON.parse(localStorage.getItem("user"));
    this.realTickers = [];
    this.state = {
      weather: [],
      reminders: [],
      notes: [],
      checklist: [],
      realTickers: [],
      deleteTickerInfo: {},
      originalName: "",
      inputWeather: "",
      inputChecklist: "",
      inputNotes: "",
      inputReminder: "",
      viewModalConfirm: false,
      isDefualWeather: false,
      isEditing: false,
      isSameNameWeather: false,
      isSameNameChecklist: false,
      isSameNameNotes: false,
      isSameNameReminder: false,
      isSameNameWeatherC: false,
      isSameNameChecklistC: false,
      isSameNameNotesC: false,
      isSameNameReminderC: false,
      validNameCity: true
    };
  }

  componentDidMount() {
    var data = {
      email: this.user.email,
      sortKey: this.user.sortKey
    };
    this.props.getTickers(data);
  }

  componentDidUpdate(prevProps) {
    if (this.props.getTickresSuccess && !prevProps.getTickresSuccess) {
      const tikers = this.props.tickersData.tickersData;
      localStorage.setItem(
        "location",
        tikers.weather[0] ? tikers.weather[0].name : ""
      );
      this.setState({
        weather: tikers.weather,
        reminders: tikers.reminders,
        notes: tikers.notes,
        checklist: tikers.checklist,
        realTickers: tikers
      });
    }

    if (this.props.putTickerSuccess && !prevProps.putTickerSuccess) {
      this.setState({ isEditing: false });
      this.props.getTickers({
        email: this.user.email,
        sortKey: this.user.sortKey
      });
    }
  }

  getArrayTicker = value => {
    switch (value) {
      case "checklist":
        return this.state.checklist;
      case "notes":
        return this.state.notes;
      case "reminders":
        return this.state.reminders;
      case "weather":
        return this.state.weather;
      default:
        return [];
    }
  };

  validateNewWeather = ticker => {
    this.setState({
      isSameNameWeather: Validate.sameName(this.state.weather, ticker.name),
      validNameCity: Validate.sameNameCity(cities, ticker.name)
    });
  };

  saveTicker = (ticker, type) => {
    if (!this.state.isEditing) {
      ticker.id = type === "weather" ? ticker.name : ticker.id;
      let data = {
        email: this.user.email,
        sortKey: this.user.sortKey,
        ticker: type,
        arrayTicker: [...this.getArrayTicker(type), ...[ticker]]
      };
      this.props.putTicker(data);
      this.setState({
        inputWeather: "",
        inputChecklist: "",
        inputNotes: "",
        inputReminder: ""
      });
      this.actionToast("Ticker has been added.");
    }
  };

  deleteTicker = () => {
    const { deleteTickerInfo } = this.state;
    let tickers = this.getArrayTicker(deleteTickerInfo.type);
    tickers.splice(deleteTickerInfo.index, 1);
    let data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      ticker: deleteTickerInfo.type,
      arrayTicker: tickers
    };
    this.props.putTicker(data);
    this.closeModal();
    this.actionToast("Ticker has been deleted.");
  };

  openDeleteModal = (index, type) => {
    if (!this.state.isEditing) {
      this.setState({
        viewModalConfirm: true,
        isDefualWeather: index === 0 && type === "weather",
        deleteTickerInfo: {
          index,
          type
        }
      });
    }
  };

  changeActive = (index, type) => {
    let tickers = this.getArrayTicker(type);
    tickers[index].active = tickers[index].active ? false : true;
    let data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      ticker: type,
      arrayTicker: tickers
    };
    this.props.putTicker(data);
    this.actionToast("Ticker has been updated.");
  };

  startFlowEdit = (index, type) => {
    if (!this.state.isEditing && type !== "weather") {
      let tickers = this.getArrayTicker(type);
      tickers[index].edit = true;

      this.setState({
        type: tickers,
        isEditing: true,
        originalName: tickers[index].name,
        inputWeather: "",
        inputChecklist: "",
        inputNotes: "",
        inputReminder: "",
        isSameNameWeather: false,
        isSameNameChecklist: false,
        isSameNameNotes: false,
        isSameNameReminder: false
      });
    }
  };

  edit = (index, type, status, name) => {
    let tickers = this.getArrayTicker(type);
    tickers[index].edit = status;

    if (status) {
      if (type === "weather")
        this.setState({
          isSameNameWeatherC: Validate.sameName(this.state.weather, name)
        });
      else if (type === "checklist")
        this.setState({
          isSameNameChecklistC: Validate.sameName(this.state.checklist, name)
        });
      else if (type === "notes")
        this.setState({
          isSameNameNotesC: Validate.sameName(this.state.notes, name)
        });
      else if (type === "reminders")
        this.setState({
          isSameNameReminderC: Validate.sameName(this.state.reminders, name)
        });
      tickers[index].name = name;
      this.setState({
        type: tickers
      });
    }
    if (!status) {
      tickers[index].name = this.state.originalName;
      this.setState({
        type: tickers,
        isEditing: false,
        isSameNameWeatherC: false,
        isSameNameChecklistC: false,
        isSameNameNotesC: false,
        isSameNameReminderC: false
      });
    }
  };

  handleKeyDown = (e, index, type) => {
    const {
      isSameNameWeatherC,
      isSameNameChecklistC,
      isSameNameNotesC,
      isSameNameReminderC
    } = this.state;
    let tickers = this.getArrayTicker(type);
    if (
      e.key === "Enter" &&
      !isSameNameWeatherC &&
      !isSameNameNotesC &&
      !isSameNameChecklistC &&
      !isSameNameReminderC &&
      tickers[index].name !== ""
    ) {
      tickers[index].edit = false;
      let data = {
        email: this.user.email,
        sortKey: this.user.sortKey,
        ticker: type,
        arrayTicker: tickers
      };
      this.props.putTicker(data);
      this.actionToast("Ticker has been updated.");
    }
  };

  saveEnter = (e, ticker, type) => {
    const {
      isSameNameWeather,
      isSameNameChecklist,
      isSameNameNotes,
      isSameNameReminder
    } = this.state;
    if (
      e.key === "Enter" &&
      !isSameNameWeather &&
      !isSameNameNotes &&
      !isSameNameChecklist &&
      !isSameNameReminder &&
      ticker.name !== ""
    ) {
      this.saveTicker(ticker, type);
    }
  };

  changeInputName = (name, source) => {
    switch (source) {
      case "weather":
        this.setState({
          inputWeather: name,
          isSameNameWeather: Validate.sameName(this.state.weather, name),
          enableButton: Validate.sameNameCity(cities, name)
        });
        break;
      case "checklist":
        this.setState({
          inputChecklist: name,
          isSameNameChecklist: Validate.sameName(this.state.checklist, name)
        });
        break;
      case "notes":
        this.setState({
          inputNotes: name,
          isSameNameNotes: Validate.sameName(this.state.notes, name)
        });
        break;
      case "reminders":
        this.setState({
          inputReminder: name,
          isSameNameReminder: Validate.sameName(this.state.reminders, name)
        });
        break;
      default:
        break;
    }
  };

  changeIndexArray = (arr, old_index, new_index, label) => {
    while (old_index < 0) {
      old_index += arr.length;
    }
    while (new_index < 0) {
      new_index += arr.length;
    }
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    let data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      ticker: label,
      arrayTicker: arr
    };
    this.props.putTicker(data);
    this.actionToast("Ticker has been updated.");
  };

  saveNewPosition = (label, arr) => {
    let data = {
      email: this.user.email,
      sortKey: this.user.sortKey,
      ticker: label,
      arrayTicker: arr
    };
    this.props.putTicker(data);
    this.actionToast("Ticker has been updated.");
  };

  closeModal = () => this.setState({ viewModalConfirm: false });

  actionToast = message => {
    ToastsStore.success(message);
  };

  render() {
    return (
      <div className={styles.__container}>
        <Tutorial stepsEnabled={true} type={'tickers'}/>
        {this.state.viewModalConfirm && (
          <ConfirmationModal
            title={"Ticker Alert"}
            label={
              this.state.isDefualWeather
                ? "Location settings will be deleted as well."
                : "This Ticker has items, If you delete it you will lose your data."
            }
            cancelText={"Cancel"}
            confirmText={"Delete Ticker"}
            onConfirm={this.deleteTicker}
            onClose={this.closeModal}
          />
        )}
        <ToastsContainer store={ToastsStore} />
        <Row className={styles.__title} style={{ paddingBottom: 6 }}>
          <Col xs={12}>Calendar Tickers</Col>
        </Row>
        <Row>
          <Col xs={12} style={{ paddingLeft: 9, paddingRight: 9 }}>
            <hr className={styles.__line} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className={styles.__subtitle_info}>
              <FaRegQuestionCircle size={20} />
              Create your own calendar ticker using the following categories.
            </div>
          </Col>
        </Row>
        <Row className={[styles.__tick_cont, 'step6-tickersPage'].join(' ')}>
          <Col lg={3} className={styles.__thick_pan}>
            <Ticker
              title={"Weather Forecast"}
              label={"weather"}
              ticker={this.state.weather}
              onClickSave={this.saveTicker}
              delete={this.openDeleteModal}
              handleSwitch={this.changeActive}
              edit={this.startFlowEdit}
              editName={this.edit}
              clickEnter={this.handleKeyDown}
              editing={this.state.isEditing}
              inputName={this.state.inputWeather}
              changeInput={this.changeInputName}
              changePosition={this.changeIndexArray}
              clickEnterSave={this.saveEnter}
              isSameName={this.state.isSameNameWeather}
              isSameNameC={this.state.isSameNameWeatherC}
              onClickSaveWeather={this.validateNewWeather}
              validCity={this.state.validNameCity}
              button={this.state.enableButton}
            />
          </Col>
          <Col lg={3} className={[styles.__thick_pan, 'step7-tickersPage'].join(' ')}>
            <Ticker
              title={"Checklist"}
              label={"checklist"}
              ticker={this.state.checklist}
              onClickSave={this.saveTicker}
              delete={this.openDeleteModal}
              handleSwitch={this.changeActive}
              edit={this.startFlowEdit}
              editName={this.edit}
              clickEnter={this.handleKeyDown}
              editing={this.state.isEditing}
              inputName={this.state.inputChecklist}
              changeInput={this.changeInputName}
              changePosition={this.changeIndexArray}
              clickEnterSave={this.saveEnter}
              isSameName={this.state.isSameNameChecklist}
              isSameNameC={this.state.isSameNameChecklistC}
            />
          </Col>
          <Col lg={3} className={[styles.__thick_pan, 'step8-tickersPage'].join(' ')}>
            <Ticker
              title={"Notes"}
              label={"notes"}
              ticker={this.state.notes}
              onClickSave={this.saveTicker}
              delete={this.openDeleteModal}
              handleSwitch={this.changeActive}
              edit={this.startFlowEdit}
              editName={this.edit}
              clickEnter={this.handleKeyDown}
              editing={this.state.isEditing}
              inputName={this.state.inputNotes}
              changeInput={this.changeInputName}
              changePosition={this.changeIndexArray}
              clickEnterSave={this.saveEnter}
              isSameName={this.state.isSameNameNotes}
              isSameNameC={this.state.isSameNameNotesC}
            />
          </Col>
          <Col lg={3} className={[styles.__thick_pan, 'step9-tickersPage'].join(' ')}>
            <Ticker
              title={"Reminders"}
              label={"reminders"}
              ticker={this.state.reminders}
              onClickSave={this.saveTicker}
              delete={this.openDeleteModal}
              handleSwitch={this.changeActive}
              edit={this.startFlowEdit}
              editName={this.edit}
              clickEnter={this.handleKeyDown}
              editing={this.state.isEditing}
              inputName={this.state.inputReminder}
              changeInput={this.changeInputName}
              changePosition={this.changeIndexArray}
              clickEnterSave={this.saveEnter}
              isSameName={this.state.isSameNameReminder}
              isSameNameC={this.state.isSameNameReminderC}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.tickersReducer.loading,
    putTickerSuccess: state.tickersReducer.putTickerSuccess,
    getTickresSuccess: state.tickersReducer.getTickresSuccess,
    tickersData: state.tickersReducer.tickersData,
    stepTutorial: state.userReducer.stepTutorial
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTickers: userData => dispatch(getTickers(userData)),
    putTicker: userData => dispatch(putTicker(userData))
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(Tickers);
